import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "@/router";

Vue.use(Vuex);
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Accept"] = "application/json";

export default new Vuex.Store({
  state: {
    session: JSON.parse(localStorage.getItem("session")) || null,
    rooms: [],
    admin: false,
    users: [],
    mixer: [],
    channels: [],
  },
  getters: {
    loggedIn(state) {
      return state.session !== null;
    },
    isAdmin(state) {
      return state.admin;
    }
  },
  mutations: {
    retrieveSession(state, session) {
      state.session = session;
    },
    destroySession(state) {
      state.session = null;
    },
    updateRooms(state, rooms) {
      state.rooms = rooms;
    },
    updateMixerChannels(state, mixerchannels) {
      state.channels = mixerchannels;
    },
    updateAdmin(state, admin) {
      state.admin = admin;
    },
    updateUsers(state, users) {
      state.users = users;
    },
    addUser(state, payload) {
      state.users.push(payload);
    },
    updateUser(state, payload) {
      const item = state.users.find(user => user.id === payload.id);
      Object.assign(item, payload);
    },
    setMixerLevel(state, payload) {
      var index = state.mixer.findIndex(mixer => mixer.bus === payload.bus && mixer.channel === payload.channel);
      if (index === -1) {
        // add missing mixer element
        state.mixer.push({
          bus: payload.bus,
          channel: payload.channel,
          level: payload.level
        });
      }
      else {
        // replace mixer element
        state.mixer.splice(index, 1, {
          bus: payload.bus,
          channel: payload.channel,
          level: payload.level
        });
      }
    }
  },
  actions: {
    retrieveSession(context, credentials) {
      var client_id = process.env.VUE_APP_CLIENT_ID;
      var client_secret = process.env.VUE_APP_CLIENT_SECRET;
      return new Promise((resolve, reject) => {
        axios
          .post("/oauth/token", {
            grant_type: "password",
            client_id: client_id,
            client_secret: client_secret,
            username: credentials.username,
            password: credentials.password
          })
          .then(response => {
            // handle refreshing logic
            response.data.expires_at = parseInt(
              Vue.moment()
                .add(response.data.expires_in, "seconds")
                .utc()
                .format("x")
            );
            // = parseInt(Vue.moment().add(60, "seconds").utc().format("x")) - parseInt(Vue.moment().utc().format("x"));
            setTimeout(
              () => context.dispatch("refreshSession"),
              (response.data.expires_in - 60) * 1000
            );
            console.log(
              "set to refresh session at " +
                Vue.moment()
                  .add(response.data.expires_in - 60, "seconds")
                  .utc()
                  .format()
            );

            localStorage.setItem("session", JSON.stringify(response.data));
            context.commit("retrieveSession", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    refreshSession(context) {
      var client_id = process.env.VUE_APP_CLIENT_ID;
      var client_secret = process.env.VUE_APP_CLIENT_SECRET;
      if (context.state.session === null) {
        console.log("we're not logged in, no reason to refresh our session");
        return;
      }
      if (
        context.state.session.expires_at >
        parseInt(
          Vue.moment()
            .utc()
            .format("x")
        ) -
          60000
      ) {
        console.log(
          "not refreshing token now since it doesn't expire until " +
            Vue.moment(context.state.session.expires_at)
              .utc()
              .format()
        );
        var difference =
          parseInt(
            Vue.moment(context.state.session.expires_at)
              .utc()
              .format("x")
          ) -
          parseInt(
            Vue.moment()
              .utc()
              .format("x")
          );
        setTimeout(
          () => context.dispatch("refreshSession"),
          difference - 60000
        );
        console.log(
          "set to refresh session at " +
            Vue.moment()
              .add(difference - 60000, "milliseconds")
              .utc()
              .format()
        );
        return;
      }
      return new Promise((resolve, reject) => {
        axios
          .post("/oauth/token", {
            grant_type: "refresh_token",
            refresh_token: context.state.session.refresh_token,
            client_id: client_id,
            client_secret: client_secret
          })
          .then(response => {
            console.log(response);
            // handle refreshing logic
            response.data.expires_at = parseInt(
              Vue.moment()
                .add(response.data.expires_in, "seconds")
                .utc()
                .format("x")
            );
            // = parseInt(Vue.moment().add(60, "seconds").utc().format("x")) - parseInt(Vue.moment().utc().format("x"));
            // fire our timeout a minute before the expiration time we were given.
            setTimeout(
              () => context.dispatch("refreshSession"),
              (response.data.expires_in - 60) * 1000
            );
            console.log(
              "set to refresh session at " +
                Vue.moment()
                  .add(response.data.expires_in - 60, "seconds")
                  .utc()
                  .format()
            );

            localStorage.setItem("session", JSON.stringify(response.data));
            context.commit("retrieveSession", response.data);
            resolve(response);
          })
          .catch(error => {
            if (error.message === "Network Error") {
              // We're offline, try again in 10 seconds...
              setTimeout(() => context.dispatch("refreshSession"), 5000);
            }
            if (error.response && error.response.status === 401) {
              // Our refresh token is busted
              console.log(error.response.data.error_description);
              localStorage.setItem("session", JSON.stringify(null));
              context.commit("retrieveSession", null);
            }
            console.log(JSON.stringify(error.response));
            console.log(JSON.stringify(error));
            reject(JSON.stringify(error));
          });
      });
    },
    destroySession(context) {
      axios.defaults.headers.common["Authorization"] =
        context.state.session.token_type +
        " " +
        context.state.session.access_token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .get("/logout")
            .then(response => {
              localStorage.setItem("session", JSON.stringify(null));
              context.commit("retrieveSession", null);
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      }
      return false;
    },
    register() {},
    getRooms(context) {
      if (context.state.session && context.state.session.token_type) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common["Authorization"] =
            context.state.session.token_type +
            " " +
            context.state.session.access_token;
          axios
            .get("/room")
            .then(response => {
              context.commit("updateRooms", response.data);
              resolve(response);
            })
            .catch(error => {
              console.log(error.response);
              if (error.message === "Network Error") {
                // We're offline, try again in 10 seconds...
                setTimeout(() => context.dispatch("getRooms"), 5000);
              }
              if (error.response && error.response.status === 401) {
                // Our refresh token is busted
                console.log(error.response.data.error_description);
                localStorage.setItem("session", JSON.stringify(null));
                context.commit("retrieveSession", null);
              }
              reject(error.response);
            });
        });
      } else {
        router.push("/login");
      }
    },
    getMixerChannels(context) {
      if (context.state.session && context.state.session.token_type) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common["Authorization"] =
            context.state.session.token_type +
            " " +
            context.state.session.access_token;
          axios
            .get("/mixerchannel")
            .then(response => {
              context.commit("updateMixerChannels", response.data);
              resolve(response);
            })
            .catch(error => {
              console.log(error.response);
              if (error.message === "Network Error") {
                // We're offline, try again in 10 seconds...
                setTimeout(() => context.dispatch("getMixerChannels"), 5000);
              }
              if (error.response && error.response.status === 401) {
                // Our refresh token is busted
                console.log(error.response.data.error_description);
                localStorage.setItem("session", JSON.stringify(null));
                context.commit("retrieveSession", null);
              }
              reject(error.response);
            });
        });
      } else {
        router.push("/login");
      }
    },
    getAdmin(context) {
      if (context.state.session && context.state.session.token_type) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common["Authorization"] =
            context.state.session.token_type +
            " " +
            context.state.session.access_token;
          axios
            .get("/admin")
            .then(response => {
              context.commit("updateAdmin", response.data);
              resolve(response);
            })
            .catch(error => {
              console.log(error.response);
              if (error.message === "Network Error") {
                // We're offline, try again in 10 seconds...
                setTimeout(() => context.dispatch("getRooms"), 5000);
              }
              if (error.response && error.response.status === 401) {
                // Our refresh token is busted
                console.log(error.response.data.error_description);
                localStorage.setItem("session", JSON.stringify(null));
                context.commit("retrieveSession", null);
              }
              reject(error.response);
            });
        });
      } else {
        router.push("/login");
      }
    },
    getUsers(context) {
      if (
        context.state.session &&
        context.state.session.token_type &&
        context.state.admin
      ) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common["Authorization"] =
            context.state.session.token_type +
            " " +
            context.state.session.access_token;
          axios
            .get("/user")
            .then(response => {
              context.commit("updateUsers", response.data);
              resolve(response);
            })
            .catch(error => {
              console.log(error.response);
              if (error.message === "Network Error") {
                // We're offline, try again in 10 seconds...
                setTimeout(() => context.dispatch("getRooms"), 5000);
              }
              if (error.response && error.response.status === 401) {
                // Our refresh token is busted
                console.log(error.response.data.error_description);
                localStorage.setItem("session", JSON.stringify(null));
                context.commit("retrieveSession", null);
              }
              reject(error.response);
            });
        });
      } else {
        router.push("/login");
      }
    },
    addUser(context, user) {
      axios.defaults.headers.common["Authorization"] =
        context.state.session.token_type +
        " " +
        context.state.session.access_token;
      return new Promise((resolve, reject) => {
        axios
          .post("/user", {
            user
          })
          .then(response => {
            context.commit("addUser", response.data);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    updateUser(context, user) {
      axios.defaults.headers.common["Authorization"] =
        context.state.session.token_type +
        " " +
        context.state.session.access_token;
      const id = user.id;
      return new Promise((resolve, reject) => {
        axios
          .put("/user/" + id, {
            user
          })
          .then(response => {
            context.commit("updateUser", response.data);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    "SOCKET_message"(context, message) {
      if (message.address && message.address.substr(1, 2) == "ch" && message.args && message.args.length > 0) {
        var parts = message.address.split("/");
        var channel = parts[2];
        if (parts[3] == "mix") {
          var bus = parts[4];
          var level = message.args[0].value;

          context.commit("setMixerLevel", {
            bus: bus,
            channel: channel,
            level: level
          });
        }
      }
    }
  }
});
